(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('nonpublicprojectsService', nonpublicprojectsService);

    nonpublicprojectsService.$inject = ['$http', '$filter', 'modelTransformer', 'messaging', 'events', 'NonPublicProject'];

    function nonpublicprojectsService($http, $filter, modelTransformer, messaging, events, NonPublicProject) {
        var baseUrl = '/api/NonPublicProject/';
        var projects = [];
        var dId = 0;
        var project = {};
        var service = {
            init: init
        };
        messaging.subscribe(events.message._GET_NON_PUBLIC_PROJECT_LIST_, getNonPublicProjects);
        messaging.subscribe(events.message._DELETE_NON_PUBLIC_PROJECT_, deleteNonPublicProject);
        messaging.subscribe(events.message._GET_NON_PUBLIC_PROJECT_, getNonPublicProject);
        messaging.subscribe(events.message._SAVE_NON_PUBLIC_PROJECT_, saveNonPublicProject);
        messaging.subscribe(events.message._SAVE_NON_PUBLIC_HOUR_, saveNonPublicHour);
        messaging.subscribe(events.message._DELETE_NON_PUBLIC_HOUR_, deleteNonPublicHour);

        return service;
        function init() {
            projects = [];
            project = {};
        }
        function deleteNonPublicHour(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteNonPublicHour/' + id)
                .then(deleteNonPublicHourSuccessHandler, deleteNonPublicHourErrorHandler);
        }
        function saveNonPublicHour(src) {            
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveNonPublicHour/', src)
                .then(saveNonPublicHourSuccessHandler, saveNonPublicHourErrorHandler);
        }

        //------------------------------------------------------

        function doFileUploads(ProjectId, LastUpdatedBy) {
            if (document.getElementById("fileUploadDocs").value != "") {
                var file = document.getElementById("fileUploadDocs").files[0];
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    data.append("file", file);                    
                    //fileName = btoa(fileName);

                    $.ajax({
                        type: "POST",
                        url: "/api/NonPublicProject/UploadFile/" + ProjectId + "/" + LastUpdatedBy + "/" + "abc",
                        contentType: false,
                        processData: false,
                        data: data,
                        success: function (result) {
                            console.info(result);
                        },
                        error: function (xhr, status, p3, p4) {
                            var err = "Error " + " " + status + " " + p3 + " " + p4;
                            if (xhr.responseText && xhr.responseText[0] == "{")
                                err = JSON.parse(xhr.responseText).Message;
                            console.error(err);
                        }
                    });
                }
                document.getElementById("fileUploadDocs").value = "";
                document.getElementById('btnSaveDoc').disabled = true;
            }
        }

        //--------------------------------------------------------
        function getNonPublicProjects(clear,id) {
            if (clear === true) {
                projects = [];
            }
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetList/'+ id;
            $http.get(baseUrl + url)
                .then(getNonPublicProjectsSuccessHandler, getNonPublicProjectsErrorHandler);
        }
        

        function getNonPublicProject(id) {

            dId = id;
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.get(baseUrl + 'Get/' + dId)
                .then(getNonPublicProjectSuccessHandler, getNonPublicProjectErrorHandler);
        }
        function deleteNonPublicProject(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteProject/' + id)
                .then(deleteNonPublicProjectSuccessHandler, deleteNonPublicProjectErrorHandler);
        }
        function saveNonPublicProject(src) {            
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveProject/', src)
                .then(saveNonPublicProjectSuccessHandler, saveNonPublicProjectErrorHandler);
        }        

        function getNonPublicProjectsSuccessHandler(results) {
            if (results.data && results.data.length) {
                var result = [];
                angular.forEach(results.data, function (d) {
                    var dr = updateOrAddNonPublicProject(d);
                    result.push(dr);
                });
                projects = result;
                messaging.publish(events.message._GET_NON_PUBLIC_PROJECT_LIST_COMPLETE_, [projects]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getNonPublicProjectsErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getNonPublicProjectSuccessHandler(results) {
            if (results.data) {
                project = updateOrAddNonPublicProject(results.data);
                messaging.publish(events.message._GET_NON_PUBLIC_PROJECT_COMPLETE_, [project]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getNonPublicProjectErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function deleteNonPublicProjectSuccessHandler(results) {
            if (results) {
                var id = angular.toJson(results.data.ProjectId);
                var ix = -1;
                var match = $filter('filter')(projects, function (p) {
                    return Number(p.ProjectId) === Number(id);
                })[0];
                if (match) {
                    ix = projects.indexOf(match);
                }
                if (ix >= 0) {
                    projects.splice(ix, 1);
                    messaging.publish(events.message._NON_PUBLIC_PROJECT_LIST_UPDATED_, [projects]);
                }
                messaging.publish(events.message._DELETE_NON_PUBLIC_PROJECT_COMPLETE_, [id]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteNonPublicProjectErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function saveNonPublicProjectSuccessHandler(results) {
            if (results.data) {
                doFileUploads(results.data.ProjectId, results.data.LastUpdatedBy);
                var result = results.data;
                project = updateOrAddNonPublicProject(result); 
                messaging.publish(events.message._SAVE_NON_PUBLIC_PROJECT_COMPLETE_, [project]);
                messaging.publish(events.message._NON_PUBLIC_PROJECT_LIST_UPDATED_, [projects]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);
            } else {
                saveNonPublicProjectErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function deleteNonPublicHourSuccessHandler(results) {
            if (results) {
                messaging.publish(events.message._DELETE_NON_PUBLIC_HOUR_COMPLETE_, [results.data.NonPublicHourId]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteNonPublicHourErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function saveNonPublicHourSuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                var fireHour = modelTransformer.transform(result, NonPublicHour);
                messaging.publish(events.message._SAVE_NON_PUBLIC_HOUR_COMPLETE_, [fireHour]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);                
            } else {
                saveNonPublicHourErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function deleteNonPublicHourErrorHandler(results) {
            messaging.publish(events.message._DELETE_NON_PUBLIC_HOUR_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete NonPublic Hour from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function updateOrAddNonPublicProject(result) {
            project = modelTransformer.transform(result, NonPublicProject);

            return project;
        }
        function getNonPublicProjectErrorHandler(results) {
            messaging.publish(events.message._GET_NON_PUBLIC_PROJECT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get NonPublic Project from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getNonPublicProjectsErrorHandler(results) {
            messaging.publish(events.message._GET_NON_PUBLIC_PROJECT_LIST_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get NonPublic Project List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function deleteNonPublicProjectErrorHandler(results) {
            messaging.publish(events.message._DELETE_NON_PUBLIC_PROJECT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete NonPublic Project from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveNonPublicProjectErrorHandler(results) {
            messaging.publish(events.message._SAVE_NON_PUBLIC_PROJECT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save NonPublic Project to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveNonPublicHourErrorHandler(results) {
            messaging.publish(events.message._SAVE_NON_PUBLIC_HOUR_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save Rural Development Hour to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
    }
})();